module.exports = __webpack_public_path__ + "static/img/illu_en_02.cfa7cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_en_02.png
// module id = CNMS
// module chunks = 1